// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import LabelsContext from '@tcp/core/src/components/common/context/LabelsContext';
import SafeComponent from '@tcp/core/src/components/common/hoc/withErrorBoundary';
import { StyledESpotPromoSkeleton } from '@tcp/core/src/components/features/browse/CategoryListingPage/styles/PaginatedPage.style';
import { StyledESpotPromoTile, StyledDamImage } from '../styles/EspotPlpPromo.style';

const EspotPlpPromo = ({
  uniqueId,
  eSpotPromoKey,
  linkedImage,
  tileHeightValue,
  tileBadgeHeightValue,
  isPLPEspot,
}) => {
  const { extraConfig } = React.useContext(LabelsContext);
  const { image, video, link } = (linkedImage && linkedImage[0]) || {};
  const { isDamImageV2EnabledPLP } = extraConfig || {};
  if (isPLPEspot) {
    if (tileHeightValue) {
      return (
        <StyledESpotPromoTile
          className="espot-plp-tile"
          key={eSpotPromoKey}
          id={uniqueId}
          tileHeightValue={tileHeightValue}
          tileBadgeHeightValue={tileBadgeHeightValue}
        >
          <StyledDamImage
            imgData={image}
            className="espot-promo-dam"
            link={link}
            videoData={video}
            isOptimizedVideo
            isDamImageV2EnabledPLP={isDamImageV2EnabledPLP}
            noLink
          />
        </StyledESpotPromoTile>
      );
    }

    return <StyledESpotPromoSkeleton />;
  }
  return (
    <StyledESpotPromoTile className="espot-plp-tile" id={uniqueId} key={eSpotPromoKey}>
      <StyledDamImage
        imgData={image}
        className="espot-promo-dam"
        link={link}
        videoData={video}
        isOptimizedVideo
        isDamImageV2EnabledPLP={isDamImageV2EnabledPLP}
        noLink
      />
    </StyledESpotPromoTile>
  );
};

EspotPlpPromo.propTypes = {
  linkedImage: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.shape({}),
      video: PropTypes.shape({}),
      link: PropTypes.shape({}),
    })
  ).isRequired,
  tileHeightValue: PropTypes.number,
  tileBadgeHeightValue: PropTypes.number,
  isPLPEspot: PropTypes.bool,
};

EspotPlpPromo.defaultProps = {
  tileHeightValue: 0,
  tileBadgeHeightValue: 0,
  isPLPEspot: false,
};

EspotPlpPromo.displayName = 'EspotPlpPromo';

export default SafeComponent(EspotPlpPromo);
export { EspotPlpPromo as EspotPlpPromoVanilla };
